var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"1.3rem","margin-bottom":"1rem"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }